const VERB = { create: "added", update: "changed", delete: "deleted", publish: "published", archive: "archived" };
const NICE = { participation: "contribution", heals: "healing", atlantisPoints: "Atlantis points", tag: "tag", group: "group" };
const SYSTEM = (b) => !b || !b.includes("@");

const ago = (t) => {
  const s = (Date.now() - new Date(t).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return new Date(t).toLocaleString();
};
const val = (v) => (v === null || v === undefined || v === "" ? "—" : String(v));

export const HistoryEntry = ({ e }) => {
  const who = SYSTEM(e.by) ? "System" : e.by.split("@")[0];
  const shown = (e.changes || []).filter((c) => !["updatedAt", "flags", "origNotes"].includes(c.k)).slice(0, 6);
  return (
    <div className="lg-card" style={{ padding: "10px 12px", marginBottom: 8 }} data-testid="history-entry">
      <div style={{ fontSize: 13.5 }}>
        <b title={e.by}>{who}</b>{" "}
        {e.summary || <>{VERB[e.action] || e.action} <b>{e.label}</b> <span style={{ color: "var(--muted)" }}>({e.type})</span></>}
      </div>
      {!e.summary && shown.length > 0 && (
        <ul style={{ margin: "4px 0 0", paddingLeft: 18, fontSize: 12.5, color: "var(--muted)" }}>
          {shown.map((c) => <li key={c.k}>{NICE[c.k] || c.k}: {val(c.from)} → {val(c.to)}</li>)}
        </ul>
      )}
      <div style={{ fontSize: 11.5, color: "var(--muted)", marginTop: 4 }} title={new Date(e.at).toLocaleString()}>{ago(e.at)}</div>
    </div>
  );
};
